export const chatPath = "/chat";
export const claudeCodePath = "/claude-code";
export const opencodePath = "/opencode";
export const docsPath = "/docs";
export const guidePath = "/guide";
export const homePath = "/";
export const legalPath = "/legal";
export const manifestoPath = "/manifesto";
export const mcpGuidePath = "/mcp";
